import React from 'react'
import LoginForm from '../components/SignInEmployer/LoginForm'
import NavBar from '../components/SignInEmployer/NavBar'
import Footer from '../components/Footer'

function SignInEmployer() {
  return (
    <div>
        <NavBar />
        <LoginForm />
        <Footer />
    </div>
  )
}

export default SignInEmployer